// Status vocabularies — the review-critical piece of the package.
//
// There are TWO distinct status vocabularies and the package models
// both explicitly (per fn-47 spec § Status vocabularies — they must
// never be collapsed into one implicit set):
//
//   - `SessionStatus`  — control-plane row status. Exactly the 8 DB
//     values. Used by `listSessions` results and inbox bucketing.
//   - `RuntimeStatus`  — live stream state derived from MA
//     `session.status_*` events by the stream reducer. Used only by
//     `SessionView`'s live header state.
//
// `isTerminalStatus()` is the SINGLE cross-vocabulary decision point.
// Composer gating and any "session is over" logic go through it —
// never through ad-hoc set membership.
/** Control-plane session row statuses — exactly the 8 DB values. */
export const SESSION_STATUSES = [
    'pending',
    'running',
    'awaiting_user',
    'awaiting_approval',
    'completed',
    'failed',
    'cancelled',
    'expired',
];
/** Stream-derived runtime statuses (MA `session.status_*` projection). */
export const RUNTIME_STATUSES = [
    'idle',
    'initializing',
    'running',
    'terminated',
    'unknown',
];
/**
 * CP terminal row statuses. A session in one of these states will
 * never transition again (terminal_at is set).
 */
const TERMINAL_STATUSES = new Set([
    'completed',
    'failed',
    'cancelled',
    'expired',
    // Stream vocabulary: MA reported the session terminated.
    'terminated',
]);
/**
 * True when the session is over — for CP terminals (`completed`,
 * `failed`, `cancelled`, `expired`) AND the stream's `terminated`.
 *
 * The only cross-vocabulary decision point: composer gating and any
 * "session is over" logic MUST go through this helper rather than
 * comparing status strings across vocabularies.
 */
export function isTerminalStatus(status) {
    return TERMINAL_STATUSES.has(status);
}
//# sourceMappingURL=status.js.map